import {StateProvider} from "./store";
import Steps from "./components/Steps";
import Layout from "./components/Layout";
import {APIProvider as GoogleMapsProvider} from "@vis.gl/react-google-maps";
import {ValidationProvider} from "@/validation";
import {ApiProvider} from "@/api";
import {ToastContainer} from "react-toastify";

export default function App() {

    return (
        <StateProvider>
            <GoogleMapsProvider apiKey={window.ein.google_maps_api_key}>
                <ValidationProvider>
                    <ApiProvider>
                        <Layout>
                            <Steps/>
                            <ToastContainer
                                position="bottom-center"
                                autoClose={5000}
                                hideProgressBar
                                newestOnTop={false}
                                closeOnClick
                                closeButton={false}
                                rtl={false}
                                pauseOnFocusLoss
                                draggable={false}
                                pauseOnHover
                                theme="colored"
                            />
                        </Layout>
                    </ApiProvider>
                </ValidationProvider>
            </GoogleMapsProvider>
        </StateProvider>

    )
}
